/* global $ */

(function (angular) {
  "use strict";

  angular.module("app").directive("member", memberDirective);

  memberDirective.$inject = [
    "Users",
    "UsersApi",
    "$rootScope",
    "$window",
    "thisSiteSettings",
  ];

  /**
   * Renders a member preview, showing profile image and basic info
   * @ngdoc direcive
   * @return {[type]} [description]
   */
  function memberDirective(
    Users,
    UsersApi,
    $rootScope,
    $window,
    thisSiteSettings,
  ) {
    function userLink($scope, el) {
      var $el = $(el);

      // properties
      $scope.thisUser = $rootScope.thisUser;
      $scope.thisSiteSettings = thisSiteSettings;

      // methods
      $scope.connect = connect;
      $scope.cancelConnect = cancelConnect;

      // set default options
      $scope.options = angular.merge(
        {
          showConnectButton: canConnect(),
          showConnectedButton: $scope.member.is_connected,
          showCancelConnectButton: canCancelConnect(),
        },
        $scope.options,
      );

      /**
       * Creates a request to connect with this member, then toggle the connect buttons
       * @return {void}
       */
      function connect() {
        Users.sendConnectRequest($scope.member.id).result.then(
          function (response) {
            $scope.options.showConnectButton = false;
            $scope.options.showCancelConnectButton = true;
            $scope.member.connect_requested = response.data.id;
          },
        );
      }

      /**
       * Creates a request to connect with this member, then toggle the connect buttons
       * @return {void}
       */
      function cancelConnect(connectRequestId) {
        Users.cancelConnectRequest(connectRequestId).result.then(function () {
          $scope.options.showConnectButton = true;
          $scope.options.showCancelConnectButton = false;
        });
      }

      /**
       * Check if the authenticated user can connect to the member
       *
       * @return {boolean}
       */
      function canConnect() {
        return (
          $scope.thisUser &&
          $scope.thisUser.id !== $scope.member.id &&
          !$scope.member.is_connected &&
          !$scope.member.connect_requested
        );
      }

      /**
       * Check if the authenticated user has a connect request to cancel for the member
       *
       * @return {boolean}
       */
      function canCancelConnect() {
        return $scope.member.connect_requested;
      }

      /**
       * Sets a class based on the space this directive occupies
       * @return {string} - class name
       */
      function getSizeClass() {
        var width = $el.outerWidth();

        if (width < 600) {
          return "size-small";
        }
        if (width < 700) {
          return "size-medium";
        }
        return "size-large";
      }

      $(window).on("resize", function () {
        $scope.sizeClass = getSizeClass();
      });

      $scope.sizeClass = getSizeClass();
    }

    return {
      restrict: "E",
      templateUrl: "directives/member.html",
      transclude: true,
      scope: {
        member: "=", // User object
        options: "=?", // Options (see default options in link function)
      },
      link: userLink,
    };
  }
})(angular);
